import * as types from "../types";
import {
  addMyCustomColor,
  deleteMyCustomColor,
  editMyCustomColor,
  getMyCustomColors,
} from "../../services/api";
export const addCategoryColor = (data) => ({
  type: types.ADD_CATEGORY_COLOR,
  // payload: data,
  payload: {},
});

export const getMyColors = () => {
  return async (dispatch) => {
    try {
      const response = await getMyCustomColors();
      dispatch({
        type: types.SET_MY_COLORS,
        payload: response?.data?.results,
      });
      console.log(response, "RQREQRE");
    } catch (error) {
      console.log(error, "RQREQRE");
    }
  };
};

// Action for API Add
export const addNewCustomColorSuccess = (data) => ({
  type: types.ADD_CUSTOM_COLOR_SUCCESS,
  payload: data,
});

export const addNewCustomColorFailure = (error) => ({
  type: types.ADD_CUSTOM_COLOR_FAILURE,
  payload: error,
});

export const addCustomColorAction = (color, setId) => async (dispatch) => {
  try {
    const response = await addMyCustomColor({
      name: "",
      color: {
        inner_color_code: color,
        outer_color_code: color,
      },
    });
    dispatch(addNewCustomColorSuccess(response.data));
    console.log(response.data, "response.data");
    setId(response.data.id);
  } catch (error) {
    dispatch(addNewCustomColorFailure(error.message));
  }
};

export const addCustomColorNewAction = (color, cb) => async (dispatch) => {
  try {
    const response = await addMyCustomColor({
      name: "",
      color: {
        inner_color_code: color,
        outer_color_code: color,
      },
    });
    dispatch(addNewCustomColorSuccess(response.data));
    console.log(response.data, "response.data");
    cb(response.data);
  } catch (error) {
    dispatch(addNewCustomColorFailure(error.message));
  }
};

// Action for API Edit
export const editCustomColorSuccess = (data) => ({
  type: types.EDIT_CUSTOM_COLOR_SUCCESS,
  payload: data,
});

export const editCustomColorFailure = (error) => ({
  type: types.EDIT_CUSTOM_COLOR_FAILURE,
  payload: error,
});

export const editCustomColorAction = (id, color, cb) => async (dispatch) => {
  try {
    const response = await editMyCustomColor(id, {
      color: {
        inner_color_code: color,
        outer_color_code: color,
      },
    });
    console.log(response, "QQQQQQQ");
    dispatch(editCustomColorSuccess(response.data));
    cb(response.data);
  } catch (error) {
    dispatch(editCustomColorFailure(error.message));
    console.log(error, "QQQQQQQ");
  }
};

// Action for API Delete
export const deleteCustomColorSuccess = (id) => ({
  type: types.DELETE_CUSTOM_COLOR_SUCCESS,
  payload: id,
});

export const deleteCustomColorFailure = (error) => ({
  type: types.DELETE_CUSTOM_COLOR_FAILURE,
  payload: error,
});

export const deleteCustomColorAction = (id, cb) => async (dispatch) => {
  try {
    await deleteMyCustomColor(id);
    dispatch(deleteCustomColorSuccess(id));
    cb();
  } catch (error) {
    dispatch(deleteCustomColorFailure(error.message));
  }
};
